import * as d3Object from "d3";
import d3Tip from "d3-tip";

const hideAllTooltips = () => {
  document.querySelectorAll(".d3-tip").forEach(element => element.remove());
};

const d3 = {
  ...d3Object,
  createTooltip: d3Tip,
  hideAllTooltips
};

export default d3;
